/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useState } from 'react';

export default function CruiseCheckoutForm() {
  const [submitted, setSubmitted] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    setSubmitted(true);
  };

  return (
    <div
      className="container my-4 p-4 bg-light rounded shadow"
      style={{ maxWidth: '700px' }}
    >
      <h1 className="mb-4 pb-2 border-bottom text-primary fw-bold">
        Passenger Information
      </h1>

      {submitted ? (
        <div className="alert alert-success" role="alert">
          Form submitted successfully!
        </div>
      ) : (
        <form onSubmit={handleSubmit}>
          <div className="bg-white p-4 rounded border shadow-sm">
            <div className="row g-3">
              <div className="col-md-6">
                <label htmlFor="title" className="form-label fw-semibold">
                  Title
                </label>
                <select id="title" className="form-select" required>
                  <option value="">Select</option>
                  <option>Mr.</option>
                  <option>Ms.</option>
                  <option>Mrs.</option>
                </select>
              </div>

              <div className="col-md-6">
                <label htmlFor="firstName" className="form-label fw-semibold">
                  First name *
                </label>
                <input
                  type="text"
                  id="firstName"
                  className="form-control"
                  required
                />
              </div>

              <div className="col-md-6">
                <label htmlFor="lastName" className="form-label fw-semibold">
                  Last name *
                </label>
                <input
                  type="text"
                  id="lastName"
                  className="form-control"
                  required
                />
              </div>

              <div className="col-md-6">
                <label htmlFor="dob" className="form-label fw-semibold">
                  Date of birth *
                </label>
                <input type="date" id="dob" className="form-control" required />
              </div>

              <div className="col-md-6">
                <label htmlFor="nationality" className="form-label fw-semibold">
                  Nationality *
                </label>
                <select id="nationality" className="form-select" required>
                  <option value="">Select</option>
                  <option>India</option>
                  <option>USA</option>
                  <option>UK</option>
                </select>
              </div>

              <div className="col-md-6">
                <label htmlFor="email" className="form-label fw-semibold">
                  Email address *
                </label>
                <input
                  type="email"
                  id="email"
                  className="form-control"
                  required
                />
              </div>

              <div className="col-md-6">
                <label htmlFor="phone" className="form-label fw-semibold">
                  Phone number *
                </label>
                <input
                  type="tel"
                  id="phone"
                  defaultValue="+91"
                  className="form-control"
                  required
                />
              </div>
            </div>
          </div>

          <button
            type="submit"
            className="btn btn-primary mt-4 w-100"
            style={{
              backgroundColor: 'orange',
              color: 'white',
              border: 'none',
              width: '80px',
              height: '40px',
              borderRadius: '5px',
              fontSize: '16px',
              marginTop: '10px',
            }}
          >
            Submit
          </button>
        </form>
      )}
    </div>
  );
}
